module.exports = __webpack_public_path__ + "static/get-started-547437cd26e7443016e7caa257d179de.png";